import React, { Fragment } from "react";
import { Container, Row, Col } from "reactstrap";
const Review = ({ sectionSpace }) => {
  return (
    <Fragment>
      <section
        id="testimonial-section"
        className={`testimonial-section ${sectionSpace} clearfix`}
      >
        <Container>
          <Row className="justify-content-center">
            <Col lg="8" md="10" xs="12">
              <div className="section-title mb-100 text-center">
                <span className="sub-title mb-15">Customer Review</span>
                <h2 className="title-text mb-0">
                  Some of our stories of product appal
                </h2>
              </div>

              <div className="review-item clearfix">
                <div className="reviewer-image">
                  <img
                    src="assets/images/testimonial/img-4.png"
                    alt="image_not_found"
                  />
                </div>
                <div className="reviewer-content">
                  <div className="reviewer-info mb-45">
                    <h3 className="reviewer-name">Nancy Pocker</h3>
                    <span className="reviewer-title">Themeforest</span>
                  </div>
                  <p className="reviewer-comment mb-30">
                    Awesome Product highly recomended Lorem ipsum dolor alamet,
                    nsectetur mayalipol tempor eiusmod tempor incubto ectetur
                    alasiqua enim ad nim veniam, quis nostrud ullam consectetur
                    mayalipol quis nostrud ullam consecte.
                  </p>
                  <div className="rating-star ul-li clearfix">
                    <ul className="clearfix">
                      <li className="rated">
                        <i className="fas fa-star"></i>
                      </li>
                      <li className="rated">
                        <i className="fas fa-star"></i>
                      </li>
                      <li className="rated">
                        <i className="fas fa-star"></i>
                      </li>
                      <li className="rated">
                        <i className="fas fa-star"></i>
                      </li>
                      <li className="rated">
                        <i className="fas fa-star"></i>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="review-item clearfix">
                <div className="reviewer-image">
                  <img
                    src="assets/images/testimonial/img-5.png"
                    alt="image_not_found"
                  />
                </div>
                <div className="reviewer-content">
                  <div className="reviewer-info mb-45">
                    <h3 className="reviewer-name">Nancy Pocker</h3>
                    <span className="reviewer-title">Themeforest</span>
                  </div>
                  <p className="reviewer-comment mb-30">
                    Awesome Product highly recomended Lorem ipsum dolor alamet,
                    nsectetur mayalipol tempor eiusmod tempor incubto ectetur
                    alasiqua enim ad nim veniam, quis nostrud ullam consectetur.
                  </p>
                  <div className="rating-star ul-li clearfix">
                    <ul className="clearfix">
                      <li className="rated">
                        <i className="fas fa-star"></i>
                      </li>
                      <li className="rated">
                        <i className="fas fa-star"></i>
                      </li>
                      <li className="rated">
                        <i className="fas fa-star"></i>
                      </li>
                      <li className="rated">
                        <i className="fas fa-star"></i>
                      </li>
                      <li className="rated">
                        <i className="fas fa-star"></i>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="review-item clearfix">
                <div className="reviewer-image">
                  <img
                    src="assets/images/testimonial/img-6.png"
                    alt="image_not_found"
                  />
                </div>
                <div className="reviewer-content">
                  <div className="reviewer-info mb-45">
                    <h3 className="reviewer-name">Nancy Pocker</h3>
                    <span className="reviewer-title">Themeforest</span>
                  </div>
                  <p className="reviewer-comment mb-30">
                    Awesome Product highly recomended Lorem ipsum dolor alamet,
                    nsectetur mayalipol tempor eiusmod tempor incubto ectetur
                    alasiqua enim ad nim veniam, quis nostrud ullam consectetur
                    mayalipol quis nostrud ullam consecte.
                  </p>
                  <div className="rating-star ul-li clearfix">
                    <ul className="clearfix">
                      <li className="rated">
                        <i className="fas fa-star"></i>
                      </li>
                      <li className="rated">
                        <i className="fas fa-star"></i>
                      </li>
                      <li className="rated">
                        <i className="fas fa-star"></i>
                      </li>
                      <li className="rated">
                        <i className="fas fa-star"></i>
                      </li>
                      <li className="rated">
                        <i className="fas fa-star"></i>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="review-item clearfix">
                <div className="reviewer-image">
                  <img
                    src="assets/images/testimonial/img-4.png"
                    alt="image_not_found"
                  />
                </div>
                <div className="reviewer-content">
                  <div className="reviewer-info mb-45">
                    <h3 className="reviewer-name">Nancy Pocker</h3>
                    <span className="reviewer-title">Themeforest</span>
                  </div>
                  <p className="reviewer-comment mb-30">
                    Awesome Product highly recomended Lorem ipsum dolor alamet,
                    nsectetur mayalipol tempor eiusmod tempor incubto ectetur
                    alasiqua enim ad nim veniam, quis nostrud ullam consectetur
                    mayalipol quis nostrud ullam consecte.
                  </p>
                  <div className="rating-star ul-li clearfix">
                    <ul className="clearfix">
                      <li className="rated">
                        <i className="fas fa-star"></i>
                      </li>
                      <li className="rated">
                        <i className="fas fa-star"></i>
                      </li>
                      <li className="rated">
                        <i className="fas fa-star"></i>
                      </li>
                      <li className="rated">
                        <i className="fas fa-star"></i>
                      </li>
                      <li className="rated">
                        <i className="fas fa-star"></i>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="review-item clearfix">
                <div className="reviewer-image">
                  <img
                    src="assets/images/testimonial/img-5.png"
                    alt="image_not_found"
                  />
                </div>
                <div className="reviewer-content">
                  <div className="reviewer-info mb-45">
                    <h3 className="reviewer-name">Nancy Pocker</h3>
                    <span className="reviewer-title">Themeforest</span>
                  </div>
                  <p className="reviewer-comment mb-30">
                    Awesome Product highly recomended Lorem ipsum dolor alamet,
                    nsectetur mayalipol tempor eiusmod tempor incubto ectetur
                    alasiqua enim ad nim veniam, quis nostrud ullam consectetur.
                  </p>
                  <div className="rating-star ul-li clearfix">
                    <ul className="clearfix">
                      <li className="rated">
                        <i className="fas fa-star"></i>
                      </li>
                      <li className="rated">
                        <i className="fas fa-star"></i>
                      </li>
                      <li className="rated">
                        <i className="fas fa-star"></i>
                      </li>
                      <li className="rated">
                        <i className="fas fa-star"></i>
                      </li>
                      <li className="rated">
                        <i className="fas fa-star"></i>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="load-more text-center">
                <button type="button" className="load-more-btn">
                  load more
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Fragment>
  );
};

export default Review;
